import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { TYPOGRAPHY } from "@store/theme/design";
import { buttonDisabledStyles, transitionHoverStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import { buttonGetHoverProps } from "@store/theme/props/button";
import { ButtonType } from "@store/Types/Button";

const getButtonProps = (color: string, type: ButtonType) => {
    return {
        shape: "rectangle",
        sizeVariant: "medium",
        buttonType: type,
        typographyProps: {
            weight: TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.smaller,
            transform: "uppercase",
            lineHeight: 1.2,
        },
        color,
        ...buttonGetHoverProps(`${color}.dark`),
        css: polyfillCss`
            min-width: 120px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            ${buttonDisabledStyles(type)}
            transition: ${transitionHoverStyles()};

            ${IconWrapper} {
                top: 0;
                height: 1em;
                color: inherit;

                svg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate3d(-50%, -50%, 0);
                }
            }
        `,
    } as ButtonPresentationProps;
};

export default {
    primary: getButtonProps("primary", ButtonType.Solid),
    secondary: getButtonProps("secondary", ButtonType.Solid),
    tertiary: {
        ...getButtonProps("secondary", ButtonType.Outline),
        ...buttonGetHoverProps("primary"),
    },
};
